import React from "react";
import { Mail, MessageSquare, RefreshCw } from "lucide-react";

function TabButton({ active, onClick, icon: Icon, label, count }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-5 py-3 font-display tracking-wide ${
        active
          ? "bg-white text-[#5b6a37] border-b-2 border-[#8da55f]"
          : "text-[#7d8e54] hover:bg-white"
      }`}
    >
      <Icon className="w-4 h-4" /> {label}
      <span className="text-xs bg-[#8da55f] text-white rounded-full px-2 py-0.5">{count}</span>
    </button>
  );
}

export default function TabStrip({ tab, onChangeTab, newsletterCount, messagesCount, onRefresh }) {
  return (
    <div className="flex border-b border-[#d6dcb6] bg-[#f6f8ec]">
      <TabButton
        active={tab === "newsletter"}
        onClick={() => onChangeTab("newsletter")}
        icon={Mail}
        label="Newsletter"
        count={newsletterCount}
      />
      <TabButton
        active={tab === "messages"}
        onClick={() => onChangeTab("messages")}
        icon={MessageSquare}
        label="Messages"
        count={messagesCount}
      />
      <div className="flex-1" />
      <button
        onClick={onRefresh}
        className="flex items-center gap-2 px-4 py-3 text-sm text-[#7d8e54] hover:text-[#5b6a37]"
        title="Refresh"
      >
        <RefreshCw className="w-4 h-4" /> Refresh
      </button>
    </div>
  );
}
